import React, { useRef, useState } from "react";
import classnames from "classnames";

import "./Avatar.styles.scss";
import { ReactComponent as AvatarPlaceholder } from "../../assets/icons/gender-fluid-avatar.svg";

interface AvatarProps {
  src?: string;
  className?: string;
  size?: number;
}

export const Avatar: React.FC<AvatarProps> = ({
  src = "",
  className = "",
  size = 40,
}) => {
  const ref = useRef<HTMLImageElement>(null);
  const [showSvg, setShowSvg] = useState<boolean>(false);

  return showSvg ? (
    <AvatarPlaceholder
      className={classnames("avatar", className)}
      width={`${size}px`}
      height={`${size}px`}
    />
  ) : (
    <img
      className={classnames("avatar", className)}
      ref={ref}
      onError={() => setShowSvg(true)}
      src={src || ""}
      width={`${size}px`}
      height={`${size}px`}
    />
  );
};
